const initialState = {
  selected: {},
  subcategories: []
}

const subcategories = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_SUBCATEGORIES':
      return Object.assign({}, state, {
        subcategories: action.subcategories
      })
    case 'SELECT_SUBCATEGORY':
      return Object.assign({}, state, {
        selected: action.category
      })
    case 'REMOVE_SUBCATEGORIES':
      return Object.assign({}, state, {
        subcategories: [],
        selected: {}
      })
    default:
      return state
  }
}

export default subcategories;
